import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

window.addEventListener("error", (e) => {
  if ((e.message || "").includes("ResizeObserver loop")) e.stopImmediatePropagation();
});

// Após um novo deploy, arquivos antigos deixam de existir: recarrega uma vez para pegar a versão nova
const reloadOnChunkError = (msg) => {
  if (/Loading chunk|ChunkLoadError|Loading CSS chunk/i.test(msg || "") && !sessionStorage.getItem("cb-chunk-reload")) {
    sessionStorage.setItem("cb-chunk-reload", "1");
    window.location.reload();
  }
};
window.addEventListener("error", (e) => reloadOnChunkError(e.message));
window.addEventListener("unhandledrejection", (e) => reloadOnChunkError(e.reason?.message || e.reason?.name));
window.addEventListener("load", () => setTimeout(() => sessionStorage.removeItem("cb-chunk-reload"), 10000));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
